"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTimeEntryRequest = exports.transformTimeEntryListResponse = exports.transformTimeEntryResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Error_1 = require("./Error");
const Date_1 = require("./Date");
const Timer_1 = require("./Timer");
function transformTimeEntryResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isProjectErrorResponse)(status, response)) {
        return (0, Error_1.transformProjectErrorResponse)(response);
    }
    const { time_entry } = response;
    return transformTimeEntryParsedResponse(time_entry);
}
exports.transformTimeEntryResponse = transformTimeEntryResponse;
function transformTimeEntryListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isProjectErrorResponse)(status, response)) {
        return (0, Error_1.transformProjectErrorResponse)(response);
    }
    const { time_entries, meta } = response;
    const { total, per_page, page, pages } = meta;
    return {
        timeEntries: time_entries.map((entry) => transformTimeEntryParsedResponse(entry)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformTimeEntryListResponse = transformTimeEntryListResponse;
function transformTimeEntryParsedResponse(entry) {
    return {
        id: entry.id,
        identityId: entry.identity_id,
        isLogged: entry.is_logged,
        startedAt: (0, Date_1.transformDateResponse)(entry.started_at, Date_1.DateFormat['YYYY-MM-DDThh:mm:ss']),
        createdAt: (0, Date_1.transformDateResponse)(entry.created_at, Date_1.DateFormat['YYYY-MM-DDThh:mm:ss']),
        clientId: entry.client_id,
        projectId: entry.project_id,
        pendingClient: entry.pending_client,
        pendingProject: entry.pending_project,
        pendingTask: entry.pending_task,
        taskId: entry.task_id,
        serviceId: entry.service_id,
        note: entry.note,
        active: entry.active,
        billable: entry.billable,
        billed: entry.billed,
        internal: entry.internal,
        retainerId: entry.retainer_id,
        duration: entry.duration,
        timer: entry.timer && (0, Timer_1.transformTimerParsedResponse)(entry.timer),
    };
}
function transformTimeEntryRequest(entry) {
    return JSON.stringify({
        time_entry: {
            id: entry.id,
            identity_id: entry.identityId,
            is_logged: entry.isLogged,
            started_at: entry.startedAt ? entry.startedAt.toISOString() : null,
            client_id: entry.clientId,
            project_id: entry.projectId,
            pending_client: entry.pendingClient,
            pending_project: entry.pendingProject,
            pending_task: entry.pendingTask,
            task_id: entry.taskId,
            service_id: entry.serviceId,
            note: entry.note,
            active: entry.active,
            billable: entry.billable,
            billed: entry.billed,
            internal: entry.internal,
            retainer_id: entry.retainerId,
            duration: entry.duration,
        },
    });
}
exports.transformTimeEntryRequest = transformTimeEntryRequest;
//# sourceMappingURL=TimeEntry.js.map